import React, { useEffect, useState, useCallback, useMemo } from 'react';
import './index.css';
import { DashBoardTitle } from '../../Title';
import { Col, Container, Row, Modal, ModalBody, Table } from 'reactstrap';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';
import Pagination from '../../Pagination/Pagination';
import { getDealerMeetingHistory, getMeetingWithStatus } from '../../../constants/apiCalls';
import closeImg from '../../../assets/img/close.png';
import { PreviewAppModal } from '../../../Pages/Registeration';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { BreadCrumbBackButton } from '../../Breadcrumbs/BreadCrumbBackButton';
import { Breadcrumbs } from '../../Breadcrumbs/Breadcrumbs';
import Storage from '../../../services/Storage';
import { UserFilters } from '../../Filters';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import actionIncon from '../../../images/actionIncon.png'
import { MeetingModal } from '../../CustomModal';
import DateService from '../../../services/DateService';
import { CommonButton } from '../../CommonComponents';
import { messages } from '../../../utils/constant-messages';
import { Permissions } from '../../../constants/Permissions';
import { Roles } from '../../../constants/Roles';
import { useSelector } from 'react-redux';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

export function OpenMeetingFTD() {
  const params = useParams();
  const navigate = useNavigate();
  // const localPermission = Storage.getUserPermissionDetail();
  const { permissionArr } = useSelector(state => state.UserGetReducer)
  const localPermission = permissionArr;
  let userInfo = Storage.getUserInfoDetail();
  let roleName = userInfo ? userInfo.role : '';
  useEffect(() => {
    if (!localPermission.includes(Permissions.OPEN_MEETING)) {
      navigate('/');
    }
  }, [...localPermission])

  let pageNo = useMemo(() => Storage.getOpenMeetingPage(), [Storage.getOpenMeetingPage()]);
  const [object, setObject] = useState('');
  const [meetingData, setMeetingData] = useState([]);
  const [modalPreview, setModalPreview] = useState(false);

  // Page
  const [count, setCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(Number(pageNo) ? Number(pageNo) : 1);
  const [pageSize, setPageSize] = useState(10);

  // Date
  const [startDate, setStartDate] = useState(Storage.getDashboardCurrentDate() ? Storage.getDashboardCurrentDate() : ''
  );
  const [endDate, setEndDate] = useState(`${params.pagetype.includes('mtd') ? Storage.getDashboardCurrentLastDate() : Storage.getDashboardCurrentDate()}`
  );

  const [isLoading, setIsloading] = useState(false);
  const [Id, setId] = useState('');

  // Meeting Modal
  const [meetingModal, setMeetingModal] = useState(false);
  const [meetingRowData, setMeetingRowData] = useState({});
  const [mActivityData, setMActivityData] = useState([]);

  const location = useLocation();

  let userDataAll = Storage.getBreadcrumbsrRecord();
  let userData = useMemo(
    () =>
      userDataAll.reduce((unique, o) => {
        if (!unique.some((obj) => obj.id === o.id && obj.role === o.role)) {
          if (o.filter) {
            unique.push(o.filter);
          }
        }
        return unique;
      }, []),
    []
  );

  useEffect(() => { }, [userData]);

  const getDealerData = useCallback((obj, page, pageSize) => {
    setIsloading(true);
    setObject(obj);
    let payload = {
      q: obj.searchQuery || '',
      pagesize: pageSize,
      page: page || 1,
      type: 'open',
      start_date: obj.startDate ? obj.startDate : '',
      end_date: obj.endDate ? obj.endDate : '',
      nh: obj.nhId || null,
      sh: obj.shId || null,
      th: obj.tmId || null,
      state_id: obj.stateId || null,
      territory_id: obj.territoryId || null,
      is_download: false,
    };
    getMeetingWithStatus((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setMeetingData(data.data);
        let count = data.total_count;
        setCount(count);
        let totalPages = Math.ceil(count / pageSize);
        setTotalPages(totalPages);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        setIsloading(false);
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
      setIsloading(false);
    }, payload);
  }, [object, page, pageSize]);

  const handleExcelSheet = useCallback((obj, page, pageSize) => {
    let payload = {
      q: obj.searchQuery || '',
      pagesize: 100000,
      page: page || 1,
      type: 'open',
      start_date: obj.startDate ? obj.startDate : '',
      end_date: obj.endDate ? obj.endDate : '',
      nh: obj.nhId || null,
      sh: obj.shId || null,
      th: obj.tmId || null,
      state_id: obj.stateId || null,
      territory_id: obj.territoryId || null,
      is_download: true,
    };
    getMeetingWithStatus((res) => {
      const { data, success, error } = res;
      if (success === true) {
        window.open(data.file, '_blank');
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        setIsloading(false);
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
      setIsloading(false);
    }, payload);
  }, [object, page, pageSize]);

  const handlePageChange = useCallback(
    (page) => {
      setPage(page);
      Storage.setOpenMeetingPage(Number(page));
      getDealerData(object, page, pageSize);
    },
    [object, page, pageSize]
  );

  const handleInputChange = useCallback(
    (e) => {
      let pageSize = parseInt(e.target.value);
      setPageSize(pageSize);
      setPage(1);
      getDealerData(object, page, pageSize);
    },
    [object, page, pageSize]
  );

  const togglePreviewApp = (val) => {
    setId(val);
    setModalPreview(!modalPreview);
  };

  const handleActionClick = (elem) => {
    setMeetingRowData(elem);
    if (elem && elem.meeting_id) {
      let payload = {
        id: elem.meeting_id
      }
      getDealerMeetingHistory((res) => {
        const { data, success, error } = res;
        if (success === true) {
          setMActivityData(data);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
      }, payload);
    }
    setMeetingModal(!meetingModal);
  }

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='openMeetingFTDTable'>
              {isLoading && <CustomSpinner />}
              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle
                          dashBorardName={`Open Meeting ${params.pagetype.includes('mtd') ? 'MTD' : 'FTD'
                            }`}
                        />
                        {!modalPreview && <BreadCrumbBackButton />}
                      </div>
                    </Col>
                    <Col xs={12}>
                      {!modalPreview && <Breadcrumbs title='Open Meeting' />}
                    </Col>
                    <Col xs={12}>
                      <UserFilters
                        page={page}
                        setPage={setPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        pageNo={pageNo}
                        userData={userData}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        dealerData={getDealerData}
                        excelData={handleExcelSheet}
                      />
                    </Col>
                  </Row>
                  {meetingData && meetingData.length > 0 ? (
                    <Row>
                      <Col xs={12}>
                        <div className='table-responsive dealerTable'>
                          <Table bordered className='table text-center'>
                            <thead>
                              <tr>
                                <th>Dealer Code</th>
                                <th>Dealership Name</th>
                                <th>Owner Name</th>
                                <th>Mobile</th>
                                <th>City/Town</th>
                                <th>SH / TM Name</th>
                                {roleName === Roles.BH_NAME && <th>NH</th>}
                                {roleName !== Roles.TM_NAME && <th>State</th>}
                                <th>Territory</th>
                                <th>Meeting Date</th>
                                <th>Updated At</th>
                                <th>Created At</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {meetingData.map((elem, index) => {
                                const {
                                  dealer_id,
                                  dealer_code,
                                  business_name,
                                  primary_contact_name,
                                  primary_contact_mobile,
                                  city,
                                  territory,
                                  meeting_date,
                                  updated_at,
                                  created_at,
                                  nh,
                                  state,
                                  created_by
                                } = elem;
                                return (
                                  <tr key={index}>
                                    <td>{dealer_code}</td>
                                    <td>
                                      <span
                                        className='dealershipLink'
                                        onClick={() => togglePreviewApp(dealer_id)}
                                      >
                                        {business_name}
                                      </span>
                                    </td>
                                    <td>{primary_contact_name}</td>
                                    <td>{primary_contact_mobile}</td>
                                    <td>{city}</td>
                                    <td>{created_by}</td>
                                    {roleName === Roles.BH_NAME && <td>{nh}</td>}
                                    {roleName !== Roles.TM_NAME && <td>{state}</td>}
                                    <td>{territory}</td>
                                    <td>{DateService.utcToLocalDate(meeting_date) || 'N/A'}</td>
                                    <td>{DateService.utcToLocalDate(updated_at) || 'N/A'}</td>
                                    <td>{DateService.utcToLocalDate(created_at) || 'N/A'}</td>
                                    <td>
                                      <div className='actionBlock'>
                                        <img src={actionIncon} alt="actionImg" onClick={() => handleActionClick(elem)} className='actionIconImg' />
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className='paginationWrapper'>
                          <span className='page-select-title'>Rows per page:</span>
                          &nbsp;&nbsp;
                          <select
                            className='form-control rows-per-page-select'
                            name='pageSize'
                            value={pageSize}
                            onChange={(e) => handleInputChange(e)}
                          >
                            <option key='5' value='5'>
                              5 Rows
                            </option>
                            <option key='10' value='10'>
                              10 Rows
                            </option>
                            <option key='15' value='15'>
                              15 Rows
                            </option>
                            <option key='20' value='25'>
                              25 Rows
                            </option>
                            <option key='25' value='30'>
                              30 Rows
                            </option>
                            <option key='30' value='50'>
                              50 Rows
                            </option>
                          </select>
                          &nbsp;&nbsp;
                          <div className='pageList'>
                            <Pagination
                              margin={2}
                              page={page}
                              count={parseInt(totalPages)}
                              pageSize={pageSize}
                              totalRecords={parseInt(count)}
                              onPageChange={handlePageChange}
                            ></Pagination>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col xs={12}>
                        {messages.COMMON.NO_RECORD_MATCH}
                      </Col>
                    </Row>
                  )}
                </Container>
              </div>

              {/* preview Modal */}
              <Modal
                id='preview-modal-openmeetingftd'
                isOpen={modalPreview}
                toggle={togglePreviewApp}
                className='previewAppModal'
                centered
              >
                <ModalBody className='pl-0 pr-0'>
                  <Container fluid>
                    <Row>
                      <Col xs={12}>
                        <div className='modalHeading'>
                          <div className='title leftTitle'>Preview App</div>
                          <div className='closeButton'>
                            <img
                              src={closeImg}
                              alt='close'
                              onClick={() => setModalPreview(!modalPreview)}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <PreviewAppModal
                          userId={Id}
                          showButtons={true}
                          location={location.pathname}
                        />
                      </Col>
                    </Row>
                    <Row className='justify-content-center'>
                      <CommonButton name={'Close'} btnClass={'btnPrimary'} type="button" onClick={() => setModalPreview(!modalPreview)} />
                    </Row>
                  </Container>
                </ModalBody>
              </Modal>

              {/* Meeting Modal */}
              <MeetingModal
                isOpen={meetingModal}
                toggle={() => setMeetingModal(!meetingModal)}
                meetingRowData={meetingRowData}
                mActivityData={mActivityData}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
